import { ScrollColumnView } from '@ipfabric/ui-components/ScrollView/ScrollColumnView';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import {
  type HideableNodeType,
  hideableNodeTypes,
  nodeIconDefaultOptions,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { updateTopologyPresetHideableNode } from 'components/Graph/commands/settings/updateTopologyPresetHideableNode';
import { getGraphNodeIconUrl } from 'components/Graph/resources/nodeIcons';
import { useLocale } from 'containers/App/LocaleContext';
import { memo } from 'react';
import { selectAvailableEntities } from '../selectors/selectAvailableEntities';
import { TopologyLayoutSettingsToggleableNodeType } from './TopologyLayoutSettingsToggleableNodeType';

const BareTopologyLayoutSettingsDevices = () => {
  const ctxProps = useGraphContextSelectors({
    availableEntities: selectAvailableEntities,
    dispatch: prop('dispatch'),
    presetEditMode: prop('layoutSettings', 'presetEditMode'),
    hiddenDeviceTypes: prop(
      'layoutSettings',
      'presetDraft',
      'hiddenDeviceTypes',
    ),
  });
  const msg = useLocale();
  const { labels } =
    msg.canvasGraph.graphSidePanel.layoutSettings.hideableNodeTypes;

  const availableDeviceTypes: readonly HideableNodeType[] =
    ctxProps.presetEditMode
      ? hideableNodeTypes
      : ctxProps.availableEntities.deviceTypes;

  // Sort node types by name.
  // concat() first to solve sort() mutable implementation.
  const sortedHideableNodeTypes = availableDeviceTypes
    .concat()
    .sort((a: HideableNodeType, b: HideableNodeType) => {
      if (labels[b] > labels[a]) {
        return -1;
      }
      if (labels[a] > labels[b]) {
        return 1;
      }
      return 0;
    });

  const handleToggleDeviceVisibility = useStableCallback(
    (nodeType: HideableNodeType) => {
      ctxProps.dispatch(updateTopologyPresetHideableNode, {
        nodeType,
        visible: ctxProps.hiddenDeviceTypes.includes(nodeType),
      });
    },
  );

  return (
    <ScrollColumnView>
      <div className='flex-1 px-5'>
        {sortedHideableNodeTypes.map((hideableNodeType: HideableNodeType) => (
          <TopologyLayoutSettingsToggleableNodeType
            nodeType={hideableNodeType}
            icon={getGraphNodeIconUrl(
              hideableNodeType,
              nodeIconDefaultOptions.style,
            )}
            key={hideableNodeType}
            onClick={handleToggleDeviceVisibility}
            visible={!ctxProps.hiddenDeviceTypes.includes(hideableNodeType)}
          />
        ))}
      </div>
    </ScrollColumnView>
  );
};

export const TopologyLayoutSettingsDevices = memo(
  BareTopologyLayoutSettingsDevices,
);
